import { Ring } from "@uiball/loaders";

const RingLoader = ({className, size=30, color="#FFFFFF", ...props}) => {
    return (
        <div {...props} className={`flex justify-center items-center h-full ${className}`}>
            <Ring size={size} lineWeight={5} speed={2} color={color}/>
        </div>
    );
};

export default RingLoader;
